export const VERSION = process.env.REACT_APP_VERSION;

export const TYPE_CHAR = "char";
export const TYPE_CLUE = "clue";
export const TYPE_PRE = "pre";

export const TYPES = [TYPE_CHAR, TYPE_CLUE, TYPE_PRE];

export const DND_PRIZE = "prize";
export const DND_KEY = "key";
export const DND_PIRATE = "pirate";

export const COLORS = ["#DCA11D", "#C3376C", "#255E5A", "#EE7E9F", "#683E00"];
export const COLOR_TEXT = "#343434";
export const COLOR_EMPTY = "#b3b3b3";
export const COLOR_CLUE = "#0071bc";
export const COLOR_CORRECT = "#8cc63f";
export const COLOR_FOCUS = "#fbb03b";

export const BOX_SIZE = 50;

export const DEFAULT_LANG = "en";
export const DEFAULT_LEVEL = 1;

export const LANGS = {
  en: "English",
  sv: "Svenska",
  ru: "русский"
};

export const LANG_SETTINGS = {
  en: {
    currency: "USD",
    currencyPrefix: "$",
    subscriptionAmount: 1000
  },
  sv: {
    currency: "SEK",
    currencySuffix: " kr",
    subscriptionAmount: 700
  },
  ru: {
    currency: "USD",
    currencySuffix: "$",
    subscriptionAmount: 1000
  }
};

export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;



// WEBPACK FOOTER //
// ./src/constants/index.js